var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#44D7B6",
    fillOpacity: 0.1804
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0003 5.97168C10.1059 5.97168 5.97168 10.1059 5.97168 15.0003C5.97168 17.8795 7.40904 20.4879 9.58313 22.1546V22.2232H9.67522C11.1812 23.3473 13.0257 24.0289 15.0003 24.0289C16.9749 24.0289 18.8194 23.3473 20.3254 22.2232H20.4175V22.1546C22.5916 20.4879 24.0289 17.8804 24.0289 15.0003C24.0289 10.1059 19.8947 5.97168 15.0003 5.97168ZM11.4558 21.2545C11.724 20.0401 12.8047 19.1291 14.0976 19.1291H15.9033C17.1962 19.1291 18.277 20.041 18.5451 21.2545C17.4906 21.8657 16.2789 22.2232 15.0005 22.2232C13.722 22.2232 12.5104 21.8657 11.4558 21.2545ZM20.0655 20.0935C19.3821 18.4683 17.7741 17.3235 15.9033 17.3235H14.0976C12.2269 17.3235 10.618 18.4692 9.93542 20.0935C8.61092 18.7762 7.77758 16.965 7.77758 15.0004C7.77758 11.0847 11.0848 7.77751 15.0005 7.77751C18.9162 7.77751 22.2234 11.0847 22.2234 15.0004C22.2234 16.965 21.39 18.7762 20.0655 20.0935Z",
    fill: "#44D7B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0004 9.58301C12.9418 9.58301 11.3889 11.1359 11.3889 13.1945C11.3889 15.253 12.9418 16.8059 15.0004 16.8059C17.0589 16.8059 18.6118 15.253 18.6118 13.1945C18.6118 11.1359 17.0589 9.58301 15.0004 9.58301ZM15.0003 15.0004C13.9368 15.0004 13.1946 14.2582 13.1946 13.1946C13.1946 12.1311 13.9368 11.3889 15.0003 11.3889C16.0639 11.3889 16.8061 12.1311 16.8061 13.1946C16.8061 14.2582 16.0639 15.0004 15.0003 15.0004Z",
    fill: "#44D7B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4a1b5c4d.svg";
export { ForwardRef as ReactComponent };